import {
  Box,
  Wrap,
  SimpleGrid,
  WrapItem,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Container,
  Flex,
} from "@chakra-ui/react";
import { Dialog } from "../components/Dialog";

const Question = ({ props, children, title }) => {
  return (
    <Container maxW="auto">
      <Dialog {...props}>
        <Accordion defaultIndex={[1]} allowToggle allowMultiple>
          <AccordionItem outline="0" border="0">
            <AccordionButton>
              <Box flex="1" textAlign="left" fontWeight="bold">
                {title}
              </Box>
              <AccordionIcon />
            </AccordionButton>
            <AccordionPanel>{children}</AccordionPanel>
          </AccordionItem>
        </Accordion>
      </Dialog>
    </Container>
  );
};
const QuestionWrapper = (props) => {
  return (
    <SimpleGrid
      {...props}
      autoFlow
      columns={[1, 2, 3]}
      spacing={5}
      mb={"2em"}
    ></SimpleGrid>
  );
};

export { Question, QuestionWrapper };
